import { FieldControllerProps } from '@dreryk/react-common';
import { Checkbox } from '@dreryk/react-components';

import { medicalServiceTranslationKeys } from '../../../translations';

import { MedicalServiceUsingDefaultConfiguration } from './usingDefaultConfiguration.types';

type MedicalServiceUsingDefaultConfigurationFieldProps = FieldControllerProps<
   'usingDefaultConfiguration',
   MedicalServiceUsingDefaultConfiguration | null
> & {
   readonly onSelectionChange: (value: boolean) => void;
};

export const MedicalServiceUsingDefaultConfigurationField = (
   props: MedicalServiceUsingDefaultConfigurationFieldProps
): JSX.Element => {
   return (
      <Checkbox
         testId={props.name}
         label={medicalServiceTranslationKeys.shared.usingDefaultConfiguration.field.label}
         controller={props.register(props.name)}
         defaultValue={props.defaultValue}
         onSelectionChange={props.onSelectionChange}
      />
   );
};
